import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ScheduledEnrollmentCardContents from 'automation-ui-canvas/components/enrollment/ScheduledEnrollmentCardContents';
import { getEnrollmentFilters, getEnrollmentSchedule } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import EventSegmentationFilters from 'automation-ui-enrollment/components/eventEnrollment/steps/EventSegmentationFilters';
import { isEventBasedWorkflow, hasEventEnrollmentTriggers } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { FirstIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TRIGGER_EXAMPLE_CONTENT_WIDTH = 370;
const FixedWidthDiv = styled.div.withConfig({
  displayName: "ExistingTriggerSidePanel__FixedWidthDiv",
  componentId: "sc-12sfkhz-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    padding: theme.space['500'],
    width: `${TRIGGER_EXAMPLE_CONTENT_WIDTH}px`
  };
});
export const ExistingTriggerSidePanel = ({
  flow,
  onClose
}) => {
  const enrollmentSchedule = getEnrollmentSchedule(flow);
  const listEnrollmentFilters = getEnrollmentFilters(flow);
  const eventEnrollentFilters = flow.getTriggers();
  const objectTypeId = flow.getObjectTypeId();
  const showEventEnrollment = isEventBasedWorkflow(flow.toHybridFlowInterface()) && hasEventEnrollmentTriggers(flow.toHybridFlowInterface());
  const existingTriggerHeader = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAssistantPanel.existingTriggerPanel.title"
      })
    }), /*#__PURE__*/_jsx(IconButton, {
      size: "sm",
      onClick: onClose,
      placement: "right",
      use: "link",
      children: /*#__PURE__*/_jsx(FirstIcon, {})
    })]
  });
  if (showEventEnrollment) {
    return /*#__PURE__*/_jsxs(FixedWidthDiv, {
      children: [existingTriggerHeader, /*#__PURE__*/_jsx(EventSegmentationFilters, {
        value: eventEnrollentFilters,
        objectTypeId: objectTypeId,
        readOnly: true
      })]
    });
  }
  return /*#__PURE__*/_jsxs(FixedWidthDiv, {
    children: [existingTriggerHeader, enrollmentSchedule && /*#__PURE__*/_jsx(ScheduledEnrollmentCardContents, {
      enrollmentSchedule: enrollmentSchedule,
      objectTypeId: objectTypeId
    }), /*#__PURE__*/_jsx(ListSegmentationFilters, {
      objectTypeId: objectTypeId,
      value: listEnrollmentFilters,
      readOnly: true
    })]
  });
};
export default ExistingTriggerSidePanel;